import * as React from "react";
const SvgPlusCircle20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "black",
        viewBox: "0 0 18 18"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M2 9a7 7 0 1 1 14 0A7 7 0 0 1 2 9Zm7-9a9 9 0 1 0 0 18A9 9 0 0 0 9 0ZM8 5v3H5v2h3v3h2v-3h3V8h-3V5H8Z",
      clipRule: "evenodd"
    })
  );
export default SvgPlusCircle20Px;
